function t(t){return"[object String]"===Object.prototype.toString.call(t)}export{t as _};
